'use client';
import React, { useEffect, useState } from 'react';
import StatCard from '@/components/ui/StatCard';
import { createClient } from '@/lib/supabase/client';
import { forgeGoalsService } from '@/lib/services/forgeGoalsService';

export default function BodyMetricsBento() {
  const [profile, setProfile] = useState<any>(null);

  useEffect(() => {
    const supabase = createClient();
    supabase?.auth?.getUser()?.then(async ({ data: { user } }) => {
      if (!user) return;
      const p = await forgeGoalsService?.getUserProfile(user?.id);
      setProfile(p);
    });
  }, []);

  const currentWeight = profile?.weight_kg ?? null;
  const targetWeight = profile?.target_weight_kg ?? null;
  const startDate = profile?.mission_start_date
    ? new Date(profile.mission_start_date)?.toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' })
    : 'Today';

  const remaining = currentWeight && targetWeight ? Math.abs(currentWeight - targetWeight)?.toFixed(1) : '—';

  return (
    <div>
      <div className="text-forge-label mb-3">Body Composition</div>
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3">
        <StatCard
          label="Current Weight"
          value={currentWeight ? currentWeight?.toString() : '—'}
          unit="kg"
          subValue="Log weight in Check-In"
          highlight="none"
          size="md"
        />
        <StatCard
          label="Target Weight"
          value={targetWeight ? targetWeight?.toString() : '—'}
          unit="kg"
          subValue={currentWeight && targetWeight ? `${remaining} kg remaining` : 'Set in goals setup'}
          highlight="green"
          size="md"
        />
        <StatCard
          label="Mission Start"
          value={startDate}
          unit=""
          subValue="Day 1 of the forge"
          highlight="none"
          size="md"
        />
        <StatCard
          label="Body Fat %"
          value="—"
          unit="%"
          subValue="Log in Check-In"
          highlight="amber"
          size="md"
        />
        <StatCard
          label="Height"
          value={profile?.height_cm ? profile?.height_cm?.toString() : '—'}
          unit="cm"
          subValue="From goals setup"
          highlight="none"
          size="md"
        />
        <StatCard
          label="Lean Mass"
          value="—"
          unit="kg"
          subValue="Calculated from check-ins"
          highlight="green"
          size="md"
        />
        <StatCard
          label="Fat Mass"
          value="—"
          unit="kg"
          subValue="Calculated from check-ins"
          highlight="none"
          size="md"
        />
        <StatCard
          label="Forge Streak"
          value="0"
          unit="days"
          subValue="Start checking in daily"
          highlight="none"
          size="md"
        />
      </div>
    </div>
  );
}